<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 red darken-4 white--text">
            Ver el motivo de rechazo
          </v-card-title>
  
          <v-card-text>  
             <p class="text-center mb-0 mt-12"> {{ input.texto_rechazo }} </p>
          </v-card-text> 
  
          <v-card-actions>
            <v-spacer></v-spacer> 
            <v-btn color="orange" outlined class="ml-8" @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script> 
export default {
    data() {
        return { 
            dialog: false, 
            input: {}
        };
    },
    methods: {
        async openmodal(row) {
            // window.console.log('>>><<<<<<',row);
            this.input = row;
            this.dialog = true
        },  
    }
};
</script>
  